module.exports = __webpack_public_path__ + "static/media/munafamart.bcc93bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/munafamart.png
// module id = 8
// module chunks = 0